import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { withTranslation } from 'react-i18next'; 

import React, { Component } from 'react'
import Slider from "react-slick"

import ObjPushCardFormation from './ObjPushCardFormation'
import { equalHeight } from "../../utilities/FrontFunctions/AoxGlobalFrontFunctions"

import '../../assets/css/0020_objects/0710_obj_carousel_formation.css';
import '../../assets/css/0020_objects/0910_obj_continuer_lecture_comptoir_dermato.css'


class ObjContinuerLectureHomeComptoirDermato extends Component {
	constructor(props) {
		super(props)
		this.state = {
		}
		this.handleButtonFav = this.props.handleButtonFav.bind(this)
	}

	componentDidMount() {
		this.applyEqualHeight();
	}
	applyEqualHeight() {
		setTimeout(() => {
			equalHeight(".obj_continuer_lecture_comptoir_dermato .obj_push_card .ctn_text_card");
		});
	}

    onSwipe() {
        if (this.slider) {
          	this.slider.innerSlider.clickable = true;
        }
	}

	render() {
        const { datasTrainings } = this.props;

		const sliderRef = slider => {this.slider = slider}
        const settings = {
            className: "obj_carousel_formation obj_carrousel_slider",
            centerMode: false,
			infinite: false,
			slidesToShow: 1,
			swipeToSlide: true,
            onSwipe: this.onSwipe.bind(this),
            dots: false,
            dotsClass:  "slider-nav",
            appendDots: dots => (
                <div className="slider-nav" >
                    <ul> {dots} </ul>
                </div>
            ),
            arrows: true,
            speed: 750,
			responsive: [
                {
                    breakpoint: 768,
                    settings: {
						dots: true,
						centerMode: true,
						centerPadding: "10%",
						arrows: false
                    }
                }
            ]
        }

		return (<>{datasTrainings && datasTrainings.length > 0 && <>
			<div className="obj_continuer_lecture_comptoir_dermato">
				<div className="ctn_title">
					<h3 className="t_title"><strong>Continuer<br /> la lecture</strong></h3>
					<p className="t_desc">{datasTrainings.length} {datasTrainings.length > 1 ?  "modules en cours de visionnage" : "module en cours de visionnage"}</p>
				</div>

				<div className="ctn_carrousel">

					<Slider {...settings} ref={sliderRef}>
						{ datasTrainings.map((datasTraining, index) => (
							<div className="item" key={index}>
                                <ObjPushCardFormation typeofPush="Formation" datasTraining={datasTraining} handleButtonFav={this.handleButtonFav}/>
							</div>
						))}
					</Slider>

				</div>
			</div>
        </>}</>)
	}

}

export default withTranslation()(withSitecoreContext()(ObjContinuerLectureHomeComptoirDermato));